import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function MetaIcon(props: IconProps) {
  const id = useId();
  return (
    <Icon fill="none" viewBox="0 0 20 14" {...props}>
      <g clipPath={`url(#meta-a-${id})`}>
        <path
          fill="#0081FB"
          d="M2.163 8.762c0 .764.168 1.35.387 1.705.287.465.715.661 1.151.661.565 0 1.079-.139 2.072-1.513.795-1.1 1.732-2.646 2.362-3.616l1.069-1.642c.741-1.14 1.599-2.407 2.584-3.266C12.591.39 13.458 0 14.331 0c1.465 0 2.86.849 3.927 2.443 1.169 1.745 1.736 3.941 1.736 6.21 0 1.347-.266 2.337-.718 3.121-.436.757-1.286 1.513-2.718 1.513v-2.159c1.225 0 1.531-1.127 1.531-2.416 0-1.838-.428-3.877-1.372-5.335-.668-1.034-1.536-1.665-2.491-1.665-1.031 0-1.862.78-2.796 2.168-.497.738-1.006 1.638-1.578 2.652l-.63 1.117c-1.265 2.245-1.586 2.757-2.219 3.6-1.108 1.477-2.055 2.037-3.302 2.037-1.478 0-2.413-.64-2.991-1.605-.474-.788-.706-1.82-.706-2.996l2.16.077Z"
        />
        <path
          fill="#0081FB"
          d="M1.707 2.595C2.697 1.068 4.126 0 5.764 0c.949 0 1.892.28 2.877 1.086 1.078.88 2.226 2.33 3.66 4.717l.513.857c1.24 2.067 1.946 3.13 2.358 3.632.531.645.904.836 1.386.836 1.226 0 1.532-1.127 1.532-2.416l1.904-.06c0 1.348-.265 2.338-.717 3.122-.437.757-1.287 1.513-2.719 1.513-.89 0-1.678-.195-2.55-1.016-.67-.632-1.453-1.754-2.056-2.764L10.16 6.511c-.9-1.504-1.725-2.625-2.203-3.133-.513-.546-1.174-1.206-2.227-1.206-.854 0-1.578.599-2.184 1.515z"
        />
        <path
          fill="#0082FB"
          d="M5.73 2.172c-.854 0-1.578.599-2.184 1.515-.858 1.294-1.383 3.223-1.383 5.075 0 .764.168 1.35.387 1.705L.71 11.681C.236 10.893.004 9.86.004 8.685c0-2.139.587-4.368 1.703-6.09C2.697 1.068 4.125 0 5.764 0l-.035 2.172Z"
        />
      </g>
      <defs>
        <clipPath id={`meta-a-${id}`}>
          <path fill="#fff" d="M0 0h20v13.287H0z" />
        </clipPath>
      </defs>
    </Icon>
  );
}
